import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Form, Checkbox } from 'semantic-ui-react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import ValidationSpan from './ValidationSpan';

const CheckboxFormValidationError = ({
  children,
  checked,
  error,
  htmlFor,
  labelText,
  labelId,
  onClick,
  position = 'right',
}) => {
  const intl = useIntl();
  return (
    <Form.Field>
      <Checkbox
        className={clsx(error && 'aridhia-is-edit-mode-validation-highlight')}
        name={htmlFor}
        checked={checked}
        onClick={() => onClick(!checked)}
        label={hasMinimumLength(labelText) ? labelText : intl.formatMessage({ id: labelId })}
      />
      <ValidationSpan validationError={error} position={position} />
      {children}
    </Form.Field>
  );
};

export default CheckboxFormValidationError;
